<template>

  <div class="card card-modal">
    <div class="card-header">
      Solicitação de reembolso
    </div>

    <div class="card-body">
      <div class="row">
        <div class="col">

          <p class="card-text">Conte-nos sobre o motivo da solicitação</p>
            <textarea cols="30" class="form-control" rows="5" v-model="form.motivo"></textarea>

            <div class="row">
              <div class="col">
                <my-alert
                  class="alert-danger text-center"
                  @done='showError = false'
                  :message ='errorMessage'
                  :show='showError'
                  :timeout="10000"
                ></my-alert>
                <my-alert
                  class="alert-success text-center"
                  @done='showSuccess = false'
                  :message ='successMessage'
                  :show='showSuccess'
                ></my-alert>
              </div>
            </div>
        </div>
      </div>
    </div>
    <div class="row card-footer ">
      <div class="col">
        <button class="btn btn-success btn-md col-6 btn-danger" @click="$emit('close')">
          Fechar
        </button>
        <button class="btn btn-success btn-md col-6 btn-success" @click="select()">
          Confirmar solicitação
        </button>
      </div>
    </div>
  </div>

</template>

<script>

export default {
  props:['recarga'],
  data() {
    return {
      form:{
        motivo:''
      }
    }
  },
  methods: {
    async confirm(){
      const dataPost = {
        recarga: this.recarga,
        motivo: this.form.motivo
      };

      let response = await this.$http.post('/v1/recargas/solicitaReembolso', dataPost);

      if (!response.success) {
        this.errorMessage = response.err;
        this.showError = true;
      } else{
        this.successMessage = "Solicitação de reembolso enviada com sucesso";
        this.showSuccess = true;
        setTimeout(() => {
          this.$emit('close');
        }, 1500);
      }
    }
  }
};
</script>
